module.exports = __webpack_public_path__ + "img/complete.119af36d.svg";